<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="defaultTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{returnOrderVO.returnOrderNo}}</td>
            <td class="tableLabel">申请人人：</td>
            <td>{{returnOrderVO.creatorName}}</td>
            <td class="tableLabel">申请日期：</td>
            <td>{{returnOrderVO.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">申请部门：</td>
            <td>{{returnOrderVO.departmentName}}</td>
            <td class="tableLabel">提交时间：</td>
            <td>{{returnOrderVO.submitTime}}</td>
            <td class="tableLabel">流程状态：</td>
            <td v-if="returnOrderVO.status === 0">
              <el-tag type="info">草稿</el-tag>
            </td>
            <td v-else>
              <el-tag type="info">{{returnOrderVO.nodeDesc}}</el-tag>
            </td>
          </tr>
        </table>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            物料信息
          </div>
          <el-table
              :data="returnOrderVO.details">
            <el-table-column prop="factoryNo" width="100" align="center" label="出厂编号"/>
            <el-table-column prop="customerName" width="110" align="center" label="客户名称"/>
            <el-table-column prop="materialNo" width="90" align="center" label="物料编号"/>
            <el-table-column prop="materialName" width="120" align="center" label="物料名称"/>
            <el-table-column prop="quantity" align="center" label="数量"/>
            <el-table-column prop="reason" width="120" align="center" label="退货理由"/>
            <el-table-column prop="remark" width="120" align="center" label="处理意见">
              <template slot-scope="scope">
                <el-input
                    v-if="nodeId ==='contractPreReview'"
                    v-model="scope.row.remark"
                    placeholder="请输入内容"
                    autosize
                    type="textarea"/>
                <el-input
                    v-else
                    v-model="scope.row.remark"
                    disabled
                    placeholder="请输入内容"
                    autosize
                    type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column prop="amount" width="150" align="center" label="预估损失金额(元)">
              <template slot-scope="scope">
                <el-input-number
                    v-if="nodeId ==='estimatedCost'"
                    v-model="scope.row.amount"
                    :precision="2"
                    :step="1"
                    placeholder="请输入内容"/>
                <el-input
                    v-else
                    v-model="scope.row.amount"
                    disabled
                    placeholder="请输入内容"/>
              </template>
            </el-table-column>
            <el-table-column prop="returnDate" width="150" align="center" label="退库大概日期">
              <template slot-scope="scope">
                <el-date-picker
                    v-if="nodeId ==='salesApprove'"
                    v-model="scope.row.returnDate"
                    size="mini"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期"
                    style="width:auto"/>
                <el-input
                    v-else
                    v-model="scope.row.returnDate"
                    disabled
                    placeholder="请输入内容"/>
              </template>
            </el-table-column>
            <el-table-column prop="logistics" width="120" align="center" label="物流信息">
              <template slot-scope="scope">
                <el-input
                    v-if="nodeId ==='salesApprove'"
                    v-model="scope.row.logistics"
                    autosize
                    type="textarea"
                    placeholder="请输入内容"/>
                <el-input
                    v-else
                    v-model="scope.row.logistics"
                    autosize
                    type="textarea"
                    disabled
                    placeholder="请输入内容"/>
              </template>
            </el-table-column>
            <el-table-column prop="outStockNo" width="110" align="center" label="处理退货单号">
              <template slot-scope="scope">
                <el-input
                    v-if="nodeId ==='warehouseApprove'"
                    v-model="scope.row.outStockNo"
                    placeholder="请输入内容"/>
                <el-input
                    v-else
                    v-model="scope.row.outStockNo"
                    disabled
                    placeholder="请输入内容"/>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name: "ReturnOrderPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        saveLoading: false,
        nodeId: 0,
        returnOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        this.$http.get("basic", `returnOrders/${this.billId}`).then((res) => {
          this.returnOrderVO = res;
        }).catch(() => {
        });
      },
      toDoApprove() {
        console.log(this.params);
        if (this.params.actionType === 0) {
          if (this.nodeId === "contractPreReview") {
            this.returnOrderVO.details.forEach((item) => {
              if (item.remark === "" || item.remark == null) {
                return this.$message.error("处理意见不能为空！！！");
              }
            });
            this.toSave();
          }else if (this.nodeId === "estimatedCost") {
            this.returnOrderVO.details.forEach((item) => {
              if (item.amount === "" || item.amount == null) {
                return this.$message.error("预估损失金额不能为空！！！");
              }
            });
            this.toSave();
          }else if (this.nodeId === "salesApprove") {
            this.returnOrderVO.details.forEach((item) => {
              if (item.returnDate === "" || item.returnDate == null) {
                return this.$message.error("退库大概日期不能为空！！！");
              }
              if (item.logistics === "" || item.logistics == null) {
                return this.$message.error("物流信息不能为空！！！");
              }
            });
            this.toSave();
          }else if (this.nodeId === "warehouseApprove") {
            this.returnOrderVO.details.forEach((item) => {
              if (item.outStockNo === "" || item.outStockNo == null) {
                return this.$message.error("处理退货单号不能为空！！！");
              }
            });
            this.toSave();
          }
        }
        if (this.params.untreadedFlowId === "0;submitter" && this.params.actionType === 2) {
          this.updateStatus();
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      toSave() {
        this.saveLoading = true;
        this.$http
          .put("basic", "returnOrders/updateDetail", this.returnOrderVO)
          .then(() => {
            // this.$message.success("保存成功");
            this.saveLoading = false;
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/csSpecialApprove",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `returnOrders/back/${this.returnOrderVO.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            console.log(this.nodeId);
          });
      },
    },
  };
</script>
<style lang="scss">
table.defaultTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.defaultTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.defaultTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
